var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.708,
    height: 130.402,
    viewBox: "0 0 121.708 130.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cfd1d3;}.b{fill:#d81212;}.c{fill:#010300;}.d{fill:#2b4d66;}.e{fill:#365e7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.417,24a2.222,2.222,0,0,0-2.03,2.243v21.66H45.04V26.247A2.223,2.223,0,0,0,43.011,24a2.173,2.173,0,0,0-2.318,2.169V47.906H36.347V26.247A2.222,2.222,0,0,0,34.317,24,2.173,2.173,0,0,0,32,26.173V53.7a8.693,8.693,0,0,0,1.739,5.216l4.781,6.375h8.693l4.781-6.375A8.693,8.693,0,0,0,53.734,53.7V26.173A2.173,2.173,0,0,0,51.417,24Z",
    transform: "translate(-32 -21.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.177,176l-2.171,80.274a4.392,4.392,0,0,0,4.442,4.487H56.6a4.392,4.392,0,0,0,4.442-4.487L58.871,176Z",
    transform: "translate(-43.657 -132.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.177,240l-2.171,62.887a4.392,4.392,0,0,0,4.442,4.487H160.6a4.392,4.392,0,0,0,4.441-4.487L162.871,240Z",
    transform: "translate(-119.404 -179.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.693,82.681v-6.52L128,73.987S130.173,24,145.387,24V82.681Z",
    transform: "translate(-101.92 -21.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M280.277,35.1a64.773,64.773,0,0,0-46.1-19.1A2.173,2.173,0,0,0,232,18.173v8.693a2.173,2.173,0,1,0,4.347,0V20.384a60.44,60.44,0,0,1,26.365,7.04L259.9,32.3a2.173,2.173,0,1,0,3.764,2.173l2.811-4.87a61.607,61.607,0,0,1,19.3,19.3L280.9,51.713a2.173,2.173,0,1,0,2.173,3.764l4.878-2.816a60.448,60.448,0,0,1,7.033,26.366h-6.478a2.173,2.173,0,0,0,0,4.347h6.478a60.447,60.447,0,0,1-7.033,26.366l-4.878-2.816a2.173,2.173,0,1,0-2.173,3.764l4.871,2.812a61.642,61.642,0,0,1-19.3,19.3l-2.707-4.69A2.174,2.174,0,0,0,260,130.282l2.712,4.7a60.446,60.446,0,0,1-26.366,7.033v-6.478a2.173,2.173,0,1,0-4.347,0v8.693a2.173,2.173,0,0,0,2.173,2.173,65.2,65.2,0,0,0,46.1-111.3Z",
    transform: "translate(-177.666 -15.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M184.64,172.356h16.87a1.916,1.916,0,1,0,0-3.83H186.626v-24.36a1.988,1.988,0,0,0-3.973,0v26.275A1.951,1.951,0,0,0,184.64,172.356Z",
    transform: "translate(-126.429 -98.497)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 4.209,
    cy: 4.209,
    rx: 4.209,
    ry: 4.209,
    transform: "translate(54.343 67.586)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus0);
export default __webpack_public_path__ + "static/media/status-0.fd3f951e0ce39b6df5fd06c9b67d6e85.svg";
export { ForwardRef as ReactComponent };